export default __webpack_public_path__ + "static/media/208.44cc497b.jpg";